import ReactDOM from "react-dom/client"
import React from "react"
import SearchApp from "@bodeboca/algolia/apps/search/search_app"
import CommonUtils from "@bodeboca/utils";

(function (Drupal, drupalSettings, document, ReactDOM, jQuery) {
  Drupal.behaviors.bb_algolia_search = {
    attach: function () {
      if (!drupalSettings['searchInitialized']) {
        const element = document.getElementById("react-app") as HTMLElement
        const root = ReactDOM.createRoot(element)
        root.render(<React.StrictMode>
          <SearchApp/>
        </React.StrictMode>,)
        CommonUtils.setIsLoading(true)

        drupalSettings['searchInitialized'] = true
      }
    },
  }
})(Drupal, drupalSettings, document, ReactDOM, jQuery)
